import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FixturePage, FixtureType } from '@cds/betting-offer';
import { OfferMapping } from '@cds/query-objects';
import { BettingOfferApi } from '@frontend/sports/betting-offer/feature/offer-service';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { DispatcherService } from '@frontend/sports/common/core/utils/dispatcher';
import { Observable } from 'rxjs';

import { HorseRacingApiService } from '../../../horse-racing-shared/services/horse-racing-api.service';
import { RedirectHelperService } from '../../../navigation-core/redirect-helper.service';
import { HorsesRaceTopnavBaseComponent } from './horses-race-topnav-base.component';

@Component({
    selector: 'ms-horses-race-topnav',
    templateUrl: 'horses-race-topnav.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HorsesRaceTopnavComponent extends HorsesRaceTopnavBaseComponent implements OnInit {
    futureFixtures: FixturePage | undefined;
    constructor(
        public sitecore: Sitecore,
        protected override redirectHelper: RedirectHelperService,
        protected override dispatcherService: DispatcherService,
        private api: HorseRacingApiService,
        protected override changeDetector: ChangeDetectorRef,
        private apiService: BettingOfferApi,
        protected override destroyRef: DestroyRef,
    ) {
        super(redirectHelper, dispatcherService, changeDetector, destroyRef);
    }

    ngOnInit(): void {
        this.getFutureFixtures()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                this.futureFixtures = data;
            });
        this.topNavOnInit(this.api.getMeetings(), this.futureFixtures!);

        this.destroyRef.onDestroy(() => {
            if (this.tournamentSelectorOpen) {
                this.toggleTournamentSelector(this.meetings, this.meeting, this.dayOfRace, this.futureFixtures!);
            }
        });
    }

    private getFutureFixtures(): Observable<FixturePage | undefined> {
        return this.apiService.getFixtureList({
            sportIds: SportConstant.Greyhounds.toString(),
            fixtureTypes: FixtureType.Antepost,
            offerMapping: OfferMapping.None,
        });
    }
}
